import React, { createContext, useContext } from "react";
import { useIsMobile } from "../utils/useIsMobile";

const MobileContext = createContext(false);

export const MobileProvider = ({ children }) => {
  const isMobile = useIsMobile(768);

  return (
    <MobileContext.Provider value={isMobile}>
      {children}
    </MobileContext.Provider>
  );
};

export const useMobileContext = () => {
  const context = useContext(MobileContext);
  if (context === undefined) {
    throw new Error("useMobileContext must be used within MobileProvider");
  }
  return context;
};
